import { HeroSplit } from "@/components/site-blocks";
import { HomeHeroForm } from "@/components/home-hero-form";
import heroImage from "@/assets/hero/crs-office-1920.webp";
import heroImageTabletAvif from "@/assets/hero/crs-office-1280.avif";
import heroImageDesktopAvif from "@/assets/hero/crs-office-1920.avif";
import heroImageTablet from "@/assets/hero/crs-office-1280.webp";
import crsLogo from "@/assets/crs-logo-white.webp";
import { RotatingHeadline } from "@/components/rotating-headline";

const HERO_HEADLINES = [
  { lead: "Power Your Home,", rest: "Lower Your Energy Bills" },
  { lead: "Generate Your Own Electricity", rest: "With MCS-Certified Solar Installation" },
  { lead: "Up To £9,000", rest: "Towards An Air Source Heat Pump With The Boiler Upgrade Scheme" },
  { lead: "Spread The Cost", rest: "With Flexible Finance Options *" },
];

export function HomeHeroSection() {
  return (
    <HeroSplit
      brandLogo={crsLogo}
      brandLogoAlt="CRS Energy"
      title="CRS Energy"
      headline={<RotatingHeadline messages={HERO_HEADLINES} />}
      description="Decades of experience across the systems that protect, heat and power your home. Our qualified and accredited team delivers dependable insulation, damp, heating and renewable energy solutions across Wales & the South West."
      image={heroImage}
      imageAlt="CRS Energy team member at the Bridgend office"
      hideImageOnMobile
      serviceFloatOverlay
      imageSources={{
        avif: [
          { src: heroImageTabletAvif, media: "(min-width: 768px) and (max-width: 1279px)" },
          { src: heroImageDesktopAvif, media: "(min-width: 1280px)" },
        ],
        webp: [
          { src: heroImageTablet, media: "(min-width: 768px) and (max-width: 1279px)" },
          { src: heroImage, media: "(min-width: 1280px)" },
        ],
      }}
      ctaPrimary={{ label: "Book a Survey", to: "/contact" }}
      ctaSecondary={{ label: "Explore Our Services", to: "/services" }}
      heroChips={[
        { icon: "wrench", label: "The Right Tools" },
        { icon: "shield", label: "The Right Price" },
        { icon: "award", label: "The Right Experience" },
      ]}
      formSlot={
        <div id="home-hero-form" className="scroll-mt-28">
          <HomeHeroForm
            sourcePage="/"
            title="Book Your Free Assessment"
            subtitle="A member of our team will be in touch shortly to discuss your requirements."
          />
        </div>
      }
    />
  );
}
